import { useDispatch } from "react-redux";
import RootState from "store/state";
import { useEffect } from "react";
import useDirectory from "./useDirectory";
import { getDirectoryOwners } from "store/directory/owners/thunks";

type Returns = [
    RootState["directory"]["owners"]["data"],
    RootState["directory"]["owners"]["getOwnersLoading"]
];

export default function useDirectoryOwners() {
    const { owners } = useDirectory();

    const dispatch = useDispatch();

    useEffect(() => {
        if (!owners.data.length) {
            dispatch(getDirectoryOwners());
        }
    }, [owners.data, dispatch]);

    return [owners.data, owners.getOwnersLoading] as Returns;
}
